import { makeStyles } from '@material-ui/core/styles'
import { Box, FormControl, MenuItem, Select, Tooltip } from '@mui/material'
import infoToolTip from 'src/assets/Buy_Policy_Images/infoToolTip.svg'
import { ncbValueObjectList } from 'src/utils/constants/BuyPolicyMotor'

const ExistingClaimsPopOver = ({ formOne, closePopover }) => {
  const classes = useStyles()

  return (
    <>
      <Box className={classes.overAllContainer}>
        <Box className={classes.expiredContainer}>
          <Box className={classes.ncbValue}>
            <Box className={classes.ncbInfoDiv}>
              <Box className={classes.expiredContent}>
                <b>NCB</b> (No Claim Bonus)
                <Tooltip
                  arrow
                  title={
                    <>
                      <Box>
                        NCB is a reward given by an insurance company to an
                        insured for not raising any claim requests during a
                        policy year
                      </Box>
                    </>
                  }
                >
                  <img src={infoToolTip} className={classes.infoImage} />
                </Tooltip>
              </Box>
              <Box className={classes.expiredContent}>on previous policy</Box>
            </Box>
            <Box>
              <FormControl>
                <Select
                  id='ncbValue'
                  name='ncbValue'
                  className={classes.inputTextField}
                  value={formOne?.values?.ncb}
                  onChange={(e) => {
                    formOne.setFieldValue('ncb', e?.target?.value, true)
                    closePopover()
                  }}
                  size='small'
                >
                  {ncbValueObjectList?.map((item) => {
                    return (
                      <MenuItem
                        value={item?.value}
                        key={item?.value}
                        className={'default-menu-item'}
                      >
                        {item?.option}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box className={classes.hr} />
          <Box className={classes.ncbSuggestionText}>
            <Box className={classes.suggestionText}>
              If the declared NCB% is wrong,
            </Box>
            <Box className={classes.suggestionText}>
              insurer may reject your claim.
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default ExistingClaimsPopOver
const useStyles = makeStyles({
  expiredContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 20px',
    gap: 10,
  },

  overAllContainer: {},

  ncbValue: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
  },
  expiredContent: {
    fontSize: '12px',
  },
  ncbInfoDiv: {
    display: 'flex',
    flexDirection: 'column',
  },
  ncbSuggestionText: {
    padding: '5px',
  },
  suggestionText: {
    lineHeight: '13px',
    fontSize: '12px',
    fontColor: '#666666',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    minWidth: 60,
  },
  hr: {
    border: '1px solid #D0D0D0',
    width: '100%',
  },
  errorStyle: { color: 'red !important ' },
  ncbHeading: { display: 'flex', flexDirection: 'row' },
  infoImage: {
    width: '15px',
    height: '15px',
    paddingLeft: '3px',
    marginTop: '-10px',
  },
})
